
import React, { useEffect, useRef } from 'react';
import OktaSignIn from '@okta/okta-signin-widget';
import '@okta/okta-signin-widget/css/okta-sign-in.min.css';

interface OktaSignInWidgetProps {
  config: any;
  onSuccess?: (res: any) => void;
  onError?: (error: any) => void;
}

const OktaSignInWidget: React.FC<OktaSignInWidgetProps> = ({ config, onSuccess, onError }) => {
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!widgetRef.current) return;

    widgetRef.current.id = 'okta-signin-widget';

    const widget = new OktaSignIn({
      ...config
    });

    widget.on('afterError', (context: any, error: any) => {
      console.error('Widget error context:', context);
      console.error('Widget error:', error);
      if (onError) onError(error);
    });

    widget.showSignInAndRedirect({
      el: '#okta-signin-widget'
    }).catch(function(error: any) {
      console.error('Widget showSignInAndRedirect error:', error);
      if (onError) {
        onError(error);
      }
    });

    return () => {
      console.log('Widget cleanup');
      try {
        widget.remove();
      } catch (e) {
        console.warn('Error during widget cleanup:', e);
      }
    };
  }, [config, onSuccess, onError]);

  return <div ref={widgetRef} />;
};

export default OktaSignInWidget;